import * as _ from 'lodash-es';
import querystring from 'querystring';
import { removeDashes } from '../../sharedF/genUuidF.mts';
export const interpolateNextPathname = ({ pathname = '/', query: queryIn, host, extScheme, locHash }) => {
    const query = _.cloneDeep(queryIn) ?? {};
    _.each(query, (value, key) => {
        if (key == 'id') {
            value = removeDashes(value) ?? value;
        }
        const beforePathname = pathname;
        pathname = _.replace(pathname, `[${key}]`, value);
        if (pathname != beforePathname) {
            delete query[key];
        }
    });
    let ret = '';
    if (host) {
        if (extScheme) {
            ret = ret + extScheme;
        }
        ret = ret + host;
    }
    ret = ret + pathname;
    if (!_.isEqual(query, {})) {
        ret = ret + '?' + querystring.stringify(query);
    }
    if (locHash) {
        ret += `#${locHash}`;
    }
    return ret;
};
